import { Location } from '../location'

export const getUserLocation = (): Promise<Location> => {
  return new Promise((resolve, reject) => {
    if (window.geoip2) {
      window.geoip2.city(
        (geo) => {
          const location: Location = {
            country: geo.country.names.en,
            province: geo.subdivisions[0].names.en,
            city: geo.city.names.en,
            postalCode: geo.postal.code,
          }
          resolve(location)
        },
        (error) => {
          reject(error)
        },
      )
    } else {
      reject(new Error('GeoIP2 script not loaded'))
    }
  })
}
